module.exports = __webpack_public_path__ + "img/img-promo02.53e0849f.png";